/**
 * Miroir frontend de `supabase/functions/_shared/leadSenders.ts`.
 * Sert à l'aperçu des emails dans `SendLeadEmailDialog` et au libellé
 * "Envoyé par X" dans `LeadEmailHistoryDialog`.
 *
 * ⚠️ Garder synchronisé avec le fichier edge function.
 */

export type LeadSenderKey = "maxime" | "gueorgui";

export interface LeadSender {
  key: LeadSenderKey;
  email: string;
  fullName: string;
  shortName: string;
  title: string;
  phone: string | null;
  calendly: string | null;
}

export const LEAD_SENDERS: Record<LeadSenderKey, LeadSender> = {
  maxime: {
    key: "maxime",
    email: "maxime@piktable.ch",
    fullName: "Maxime Dumont",
    shortName: "Maxime",
    title: "Fondateur de Piktable",
    phone: "+41 79 774 97 93",
    calendly: "https://calendly.com/maxdmnt/piktable",
  },
  gueorgui: {
    key: "gueorgui",
    email: "gueorgui@piktable.ch",
    fullName: "Gueorgui Petrov",
    shortName: "Gueorgui",
    title: "Co-fondateur de Piktable",
    phone: null,
    calendly: null,
  },
};

export function resolveSenderFromEmail(email: string | undefined | null): LeadSender {
  if (!email) return LEAD_SENDERS.maxime;
  const match = Object.values(LEAD_SENDERS).find(
    (s) => s.email.toLowerCase() === email.toLowerCase()
  );
  return match ?? LEAD_SENDERS.maxime;
}

export function getSenderByKey(key: string | null | undefined): LeadSender {
  if (key && key in LEAD_SENDERS) {
    return LEAD_SENDERS[key as LeadSenderKey];
  }
  // Fallback : anciens emails sans sender_key → Maxime (réalité historique)
  return LEAD_SENDERS.maxime;
}
